import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { ReviewTargetsActions } from '@actions/index'
import * as fromReviewTargets from '@reducers/index'
import { Observable } from 'rxjs';
import { ReviewTargetModel, RequestModel } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class ReviewTargetsFacadeService {

    constructor(private store: Store<any>, public router: Router, ) { }

    getReviewTargets$(): Observable<ReviewTargetModel[]> {
        return this.store.select(fromReviewTargets.getReviewTargets)
    }

    getEnableAllReviewTargets$(): Observable<boolean> {
        return this.store.select(fromReviewTargets.getEnableAllReviewTargets)
    }

    getSelectedReviewTarget$(): Observable<ReviewTargetModel> {
        return this.store.select(fromReviewTargets.getSelectedReviewTarget)
    }

    getReviewTargetsTotal$(): Observable<number> {
        return this.store.select(fromReviewTargets.getTotalReviewTargets)
    }

    getReviewTargetError$(): Observable<string> {
        return this.store.select(fromReviewTargets.getErrorReviewTargets)
    }

    getLocationReviewTargetWithErrors$(): Observable<boolean> {
        return this.store.select(fromReviewTargets.getLocationReviewTargetWithErrors)
    }

    getReviewTargetToIntegrate$(): Observable<string> {
        return this.store.select(fromReviewTargets.getReviewTargetToIntegrate)
    }

    getShowRevieTargetLocationFormAfterRedirect$(): Observable<boolean> {
        return this.store.select(fromReviewTargets.getShowRevieTargetLocationFormAfterRedirect)
    }

    searchAllReviewTargets(data: { page: number, size: number }) {
        const request: RequestModel = {
            params: `reviewTargets?&page=${data.page}&size=${data.size}`
        }
        this.store.dispatch(ReviewTargetsActions.searchAllReviewTargets({ request }));
    }

    searchReviewTargetsByLocation(data: { page: number, size: number }) {
        const request: RequestModel = {
            params: `reviewTargets/location?&page=${data.page}&size=${data.size}`
        }
        this.store.dispatch(ReviewTargetsActions.searchReviewTargetsByLocation({ request }));
    }

    searchAllReviewTargetsByLocation() {
        const request: RequestModel = {
            params: `reviewTargets/location`
        }
        this.store.dispatch(ReviewTargetsActions.searchAllReviewTargetsByLocation({ request }));
    }

    createReviewTarget(reviewTarget: ReviewTargetModel) {
        const request: RequestModel = {
            params: `reviewTargets`,
            payload: reviewTarget
        }
        this.store.dispatch(ReviewTargetsActions.saveReviewTarget({ request }));
    }

    deleteReviewTarget(reviewTargetId: string) {
        const request: RequestModel = {
            params: `reviewTargets/${reviewTargetId}`,
            payload: reviewTargetId
        }
        this.store.dispatch(ReviewTargetsActions.deleteReviewTarget({ request }));
    }

    editReviewTargetByLocation(payload: {reviewTarget: ReviewTargetModel}, showToastMessage?: boolean) {
        const request: RequestModel = {
            params: `reviewTargets/location`,
            payload: payload
        }
        this.store.dispatch(ReviewTargetsActions.saveReviewTargetByLocation({ request, showToastMessage: (showToastMessage != null && showToastMessage != undefined) ? showToastMessage : true }));
    }

    searchAllReviewTargetsByQueryByLocation(data: { page: number, size: number, query: string }) {
        const request: RequestModel = {
            params: `reviewTargets/autocomplete?&page=${data.page}&size=${data.size}&query=${data.query}`,
        }
        this.store.dispatch(ReviewTargetsActions.searchAllReviewTargetsByQueryByLocation({ request }));
    }

    switchAllReviewTargets(data: { page: number, size: number, switchState: boolean }) {
        const request: RequestModel = {
            params: `reviewTargets/switch?&page=${data.page}&size=${data.size}&switch=${data.switchState}`,
        }
        this.store.dispatch(ReviewTargetsActions.switchAllReviewTargets({ request }));
    }

    switchAllReviewTargetsByLocation(data: { page: number, size: number, switchState: boolean }) {
        const request: RequestModel = {
            params: `reviewTargets/location/switch?&page=${data.page}&size=${data.size}&switch=${data.switchState}`,
        }
        this.store.dispatch(ReviewTargetsActions.switchAllReviewTargetsByLocation({ request }));
    }

    setSelectedReviewTarget(reviewTarget: ReviewTargetModel) {
        this.store.dispatch(ReviewTargetsActions.setSelectedReviewTarget({ reviewTarget }));
    }

    getReviewSourcesQuery$() {
        return this.store.select(fromReviewTargets.getReviewSourcesByQuery)
    }

    addReviewSourceToLocation(reviewTarget: ReviewTargetModel){
        const request: RequestModel = {
            params: `reviewTargets/location/add`,
            payload: reviewTarget
        }
        this.store.dispatch(ReviewTargetsActions.addReviewSourceToLocation({ request }));
    }
    
    deleteReviewTargetByLocation(reviewTargetId: string) {
        const request: RequestModel = {
            params: `reviewTargets/location/delete`, 
            payload: reviewTargetId
        }
        this.store.dispatch(ReviewTargetsActions.deleteReviewTargetByLocation({ request }));
    }

    searchLocationReviewTargetWithErrors(data: { locationId : string}) {
        const request: RequestModel = {
            params: `reviewTargets/location/error-review-target?locationId=${data.locationId}`,
        }
        this.store.dispatch(ReviewTargetsActions.searchLocationReviewTargetWithErrors({ request }));
    }

    updateGMBReviewTargetByLocation(reviewTargetId: string, reviewTarget: ReviewTargetModel) {
        const request: RequestModel = {
            params: `reviewTargets/location/update-gmb`, 
            payload: {reviewTargetId, reviewTarget}
        }
        this.store.dispatch(ReviewTargetsActions.updateGMBReviewTargetByLocation({ request }));
    }

    setUIReviewTargetList(list: ReviewTargetModel[]){
        this.store.dispatch(ReviewTargetsActions.setUIReviewTargetList({list}))
    }

    setReviewTargetToIntegrate(reviewTargetId: string) {
        this.store.dispatch(ReviewTargetsActions.setReviewTargetToIntegrate({ reviewTargetId }));
    }

    setShowRevieTargetLocationFormAfterRedirect(showForm: boolean) {
        this.store.dispatch(ReviewTargetsActions.setShowRevieTargetLocationFormAfterRedirect({ showForm }));
    }
    
    updateFacebookReviewTargetByLocation(reviewTargetId: string, reviewTarget: ReviewTargetModel) {
        const request: RequestModel = {
            params: `reviewTargets/location/update-facebook`, 
            payload: {reviewTargetId, reviewTarget}
        }
        this.store.dispatch(ReviewTargetsActions.updateFacebookReviewTargetByLocation({ request }));
    }
    enabledOrDisabled(reviewTarget: ReviewTargetModel) {
        const request: RequestModel = {
            params: `reviewTargets`,
            payload: reviewTarget
        }
        this.store.dispatch(ReviewTargetsActions.disableOrEnabled({ request }));
    }
}
